// Blog content for LightSpeed ROI. FRONTEND MOCK.
import { IMAGES } from "./mock";

export const BLOG_POSTS = [
  {
    slug: "missed-calls-cost-houston-contractors",
    title: "Every Missed Call Is a Job Your Competitor Just Booked",
    excerpt:
      "In home services, the first business to pick up wins the job. Here's what those unanswered calls are really costing Houston contractors — and the fix.",
    category: "Lead Gen",
    date: "July 12, 2025",
    readTime: "4 min read",
    image: IMAGES.missedCall,
    body: [
      "You're on a job. Hands full, phone buzzing in your pocket. By the time you call back an hour later, the homeowner already booked the next company on their list. That's not a rare event — for most home service pros it happens several times a week.",
      "Homeowners with an emergency don't wait. When the AC quits in July or a pipe bursts at midnight, they call three companies in a row and hire whoever answers first. Speed beats reputation, price, and even reviews in that moment.",
      "The math is brutal. If your average job is worth $400 and you miss just five calls a week, that's $2,000 in work walking to a competitor every single week — over $100,000 a year.",
      "The fix isn't hiring a receptionist. It's a missed-call text back that fires within 3 seconds and an AI assistant that answers, qualifies, and books while you keep working. The phone stops being a leak and starts being a pipeline.",
      "That's the whole idea behind the LightSpeed ROI stack: never let a call turn into a lost job again.",
    ],
  },
  {
    slug: "why-reviews-book-jobs",
    title: "Why Google Reviews Book More Jobs Than Any Ad You'll Run",
    excerpt:
      "Homeowners trust other homeowners. Here's how a simple review automation turns every finished job into your best salesperson.",
    category: "Reputation",
    date: "July 5, 2025",
    readTime: "3 min read",
    image: IMAGES.crew,
    body: [
      "Before a homeowner in League City calls you, they Google you. What they see next to your name — a 4.9 with 120 reviews or a 4.1 with 9 — decides whether they dial or scroll past.",
      "Great work doesn't automatically become great reviews. Happy customers forget. Busy pros forget to ask. The result is a review count that doesn't reflect how good you actually are.",
      "Review automation fixes that quietly. The moment a job is marked complete, the customer gets a friendly text with a one-tap link to leave a Google review. No awkward asking, no forgetting.",
      "Contractors who turn this on typically go from a review or two a month to double digits — and those reviews compound, pushing you up the map pack where the calls come from.",
    ],
  },
  {
    slug: "website-built-for-free-catch",
    title: "\"Website Built for Free\" — Where's the Catch?",
    excerpt:
      "A free website sounds too good to be true. Here's exactly how the model works and why it's built to make you money, not cost you.",
    category: "How It Works",
    date: "June 28, 2025",
    readTime: "5 min read",
    image: IMAGES.heroContractor,
    body: [
      "When someone says they'll build your website for free, your guard goes up — and it should. So here's the honest version, no fine print.",
      "The website itself is genuinely free to build. No setup fee. The reason that works is the $597/month system that runs on top of it: the AI assistant, missed-call text back, review automation, CRM, and follow-up. That's what actually books jobs, and that's what the monthly covers.",
      "You own everything from day one — the site, the domain, the data. Cancel anytime and it's yours. There's no hostage situation, no ticket queue, no account manager you've never met.",
      "The model only works if you win. If the system doesn't put booked jobs on your calendar, you cancel and I've built a free website for nothing. That keeps the incentives pointed the right direction — at your results.",
    ],
  },
  {
    slug: "one-person-vs-big-agency",
    title: "One Accountable Person vs. the Big Agency Machine",
    excerpt:
      "Why working with one person who actually does the work beats a bloated agency for home service businesses.",
    category: "Real Talk",
    date: "June 20, 2025",
    readTime: "4 min read",
    image: IMAGES.founder,
    body: [
      "You already know how the big agency story ends. Sold by a smooth closer, handed off to someone junior, and six months later you're staring at a dashboard full of impressions and clicks with nothing new on the calendar.",
      "The problem isn't effort — it's distance. You're one of dozens in a queue. Every change goes through a ticket system. Weeks pass. Nobody in that building knows your trade or your town.",
      "Working with one accountable person flips that. You text me, I make the change — usually same day. Small roster, real attention. I report on the only numbers that pay you: calls and booked jobs.",
      "For a home service business, that closeness is the whole advantage. It's why this model works when the big-agency version doesn't.",
    ],
  },
];

export const getPost = (slug) => BLOG_POSTS.find((p) => p.slug === slug);
